@if (auth.user$ | async; as user) {
    <div class="nav-bar">
        <div class="nav-header-container">
            <div>
                <img ngSrc="assets/carebrokerage-evaran-white.svg" alt="logo" class="logo" width="140" height="30" priority>
            </div>
            <div class="notification-border">
                <button cll-icon-button appearance="outline"
                        [routerLink]="['/messages/']">
                    <cll-icon class="mail-icon" type="outlined">mail</cll-icon>
                </button>
                <span class="notification-icon" *ngIf="(user.unread_messages?.length ?? 0) > 0">
                    {{ user.unread_messages?.length }}
                </span>
            </div>
        </div>
        <div class="primary-section">
            <div *ngIf="!showSettingsNav && !showCareNav && !showPackagesNav" @fadeMenu>
                <nav>
                    <ul>
                        <li>
                            <a routerLink="/" class="nav-item">
                                <cll-icon type="outlined">grid_view</cll-icon>
                                Dashboard
                            </a>
                        </li>
                    </ul>
                </nav>
                <div class="title-container"><span>Manage</span></div>
                <nav>
                    <ul>
                        @for (link of manageNavLinks.slice(0, 3); track link.label) {
                            <li>
                                <a [routerLink]="link.route" (click)="logLinkClick(link.route)"
                                   routerLinkActive="active"
                                   class="nav-item">
                                    <cll-icon type="outlined">{{ link.icon }}</cll-icon>
                                    {{ link.label }}
                                </a>
                            </li>
                        }
                        <li>
                            <button (click)="logLinkClick('packages')" class="nav-item">
                                <cll-icon type="outlined">inventory_2</cll-icon>
                                Packages
                            </button>
                        </li>
                        @for (link of manageNavLinks.slice(3); track link.label) {
                            <li>
                                <a [routerLink]="link.route" (click)="logLinkClick(link.route)"
                                   routerLinkActive="active"
                                   class="nav-item">
                                    <cll-icon type="outlined">{{ link.icon }}</cll-icon>
                                    {{ link.label }}
                                </a>
                            </li>
                        }
                    </ul>
                </nav>
                <div class="title-container"><span>Insights</span></div>
                <nav>
                    <ul>
                        <li>
                            <a routerLink="/reports" class="nav-item" routerLinkActive="active">
                                <cll-icon type="outlined">assignment</cll-icon>
                                Reports
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <div *ngIf="showSettingsNav && !showCareNav && !showPackagesNav" @fadeMenu>
                <nav>
                    <ul>
                        <li>
                            <a routerLink="/" (click)="logLinkClick('/')" class="nav-item">
                                <cll-icon type="outlined">chevron_left</cll-icon>
                                Dashboard
                            </a>
                        </li>
                    </ul>
                </nav>
                <div class="title-container"><span>System settings</span></div>
                <nav>
                    <ul>
                        @for (link of filteredSettingsNavLinks; track link.label) {
                            <li>
                                <a [routerLink]="link.route" (click)="logLinkClick(link.nav)"
                                   [routerLinkActive]="link.label !== 'Care Option' ? 'active' : ''"
                                   class="nav-item">
                                    <cll-icon type="outlined">{{ link.icon }}</cll-icon>
                                    {{ link.label }}
                                </a>
                            </li>
                        }
                    </ul>
                </nav>
            </div>
            <div *ngIf="showCareNav && !showSettingsNav && !showPackagesNav" @fadeMenu>
                <nav>
                    <ul>
                        <li>
                            <button (click)="settingsNav()" class="nav-item">
                                <cll-icon type="outlined">chevron_left</cll-icon>
                                Settings
                            </button>
                        </li>
                    </ul>
                </nav>
                <div class="title-container"><span>Care Option</span></div>
                <nav>
                    <ul>
                        @for (link of careNavLinks; track link.label) {
                            <li>
                                <a [routerLink]="link.route" (click)="logLinkClick(link.nav)" routerLinkActive="active"
                                   class="nav-item">
                                    <cll-icon type="outlined">{{ link.icon }}</cll-icon>
                                    {{ link.label }}
                                </a>
                            </li>
                        }
                    </ul>
                </nav>
            </div>
            <div *ngIf="showPackagesNav && !showSettingsNav" @fadeMenu>
                <nav>
                    <ul>
                        <li>
                            <button (click)="logLinkClick('/')" class="nav-item">
                                <cll-icon type="outlined">chevron_left</cll-icon>
                                Full menu
                            </button>
                        </li>
                    </ul>
                </nav>
                <div class="title-container"><span>Packages</span></div>
                <nav>
                    <ul>
                        @for (link of packagesNavLinks; track link.label) {
                            <li>
                                <a [routerLink]="link.route" (click)="logLinkClick(link.nav)" routerLinkActive="active"
                                   class="nav-item">
                                    <cll-icon type="outlined">{{ link.icon }}</cll-icon>
                                    {{ link.label }}
                                </a>
                            </li>
                        }
                    </ul>
                </nav>
            </div>
        </div>
        <div class="platform-profile-section" *ngIf="!showSettingsNav && !showCareNav" @fadeMenu>
            <div class="title-nav-container">
                <div class="title-container"><span>Platform</span></div>
                <nav>
                    <ul>
                        <li>
                            <button (click)="logLinkClick('/settings')" class="nav-item">
                                <cll-icon type="outlined">settings</cll-icon>
                                System settings
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>

        </div>
        <div class="search-user-container">
            <div class="search-padding">
                <div class="nav-search-container">
                    <cll-icon class="search-icon">search</cll-icon>
                    <input type="text" class="search-input" placeholder="Search" />
                </div>
            </div>

            <div class="profile-container">
                <div class="profile-header">
                    <div class="avatar-icon">
                        <cll-avatar [size]="40" [src]="user.person.avatar_url" />
                    </div>
                    <div class="user-container">
                    <span class="profile-name">{{
                            (user.person.given_name || '') + ' ' + (user.person.family_name ||
                                '')
                        }}</span>
                        <span class="profile-email">{{ (user.email || '') }}</span>
                    </div>
                    <div>
                        <button cll-icon-button [cllMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
                                class="more-button">
                            <cll-icon>more_vert</cll-icon>
                        </button>
                        <ng-template #menu>
                            <cll-menu>
                                <a cllMenuItem routerLink="/users/{{ user.id }}">
                                    <cll-icon type="outlined">person</cll-icon>

                                    Profile
                                </a>
                                <button cllMenuItem (click)="logout()">
                                    <cll-icon>logout</cll-icon>

                                    Logout
                                </button>
                            </cll-menu>
                        </ng-template>
                    </div>
                </div>
                <div class="profile-org-role-container">
                    @if (settings$ | async; as settings) {
                        <div class="profile-org-role-section">
                            <span class="profile-org-role-label">Organisation</span>

                            <span class="profile-org-role-value" [cllTooltip]="`${settings.data.system_name}`">{{ settings.data.system_name }}</span>
                        </div>
                    }
                    <div class="profile-org-role-section">
                        <span class="profile-org-role-label">Position</span>
                        <span class="profile-org-role-value">{{ user.permissions?.permission_name ?? 'No role' }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
